import { ClaimByStatus } from 'containers/AppContainer/typings';
import { DEFAULT_LAWYER_CODE } from 'containers/RecapManagerPage/constants';
import { compact, get, isEmpty } from 'lodash';

export const shouldDisplayAssignmentDialogButton = (claim: any): boolean =>
  !isEmpty(claim.documents) &&
  (isEmpty(
    get(claim, 'assignment', []).filter((el: any) => el.assignedManagerCode),
  ) ||
    !helper.isLawyerAssigned(claim) ||
    helper.isAssignedToReserveLawyer(claim));

export const shouldDisplayAssignmentDialogButtonCourtManager = (
  claim: any,
): boolean => {
  return claim?.assignedLawyers
    ? isEmpty(get(claim, 'assignedLawyers', []).filter((el: any) => el)) &&
        !isEmpty(claim?.assignedSubService)
    : isEmpty(claim?.assignedLawyer) && !isEmpty(claim?.assignedSubService);
};
export const isLawyerAssigned = (claim: any): boolean =>
  !isEmpty(
    get(claim, 'assignment', []).filter((el: any) => el.assignedLawyer),
  ) || !!claim?.isSagisLawyerAssigned;

export const isAssignedToReserveLawyer = (claim: any): boolean =>
  !isEmpty(
    get(claim, 'assignment', []).filter(
      (el: any) => el.assignedLawyer === DEFAULT_LAWYER_CODE && !el.isDeleted,
    ),
  );

export const helper = { isLawyerAssigned, isAssignedToReserveLawyer };

export const getClaimNumbers = (claims: ClaimByStatus[]) =>
  compact(claims.map(claim => claim.claimNumber));
